import React, { useRef, useState } from 'react';
import { Play } from 'lucide-react';

const VIDEO_SRC = '/videos/counselor-testimonial.mp4';
const POSTER_SRC = '/videos/counselor-testimonial-poster.jpg';

/**
 * Click-to-play testimonial video. The 13 MB mp4 is only fetched when the
 * visitor presses play (preload="none") — page load cost is the 52 KB poster.
 */
export default function VideoTestimonial({ className = '' }: { className?: string }) {
  const [started, setStarted] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const start = () => {
    setStarted(true);
    videoRef.current?.play();
  };

  return (
    <div
      className={`relative rounded-2xl overflow-hidden shadow-xl shadow-brand-900/10 border border-gray-200 bg-brand-950 ${className}`}
    >
      <video
        ref={videoRef}
        controls={started}
        preload="none"
        playsInline
        poster={POSTER_SRC}
        className="w-full aspect-video object-cover"
      >
        <source src={VIDEO_SRC} type="video/mp4" />
        Your browser does not support video playback.
      </video>

      {!started && (
        <button
          onClick={start}
          aria-label="Play video testimonial from Dr. Dione Floyd"
          className="absolute inset-0 group"
        >
          <span className="absolute inset-0 bg-gradient-to-t from-brand-950/70 via-transparent to-transparent" />
          <span className="absolute inset-0 flex items-center justify-center">
            <span className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-white/95 shadow-2xl flex items-center justify-center group-hover:scale-105 transition-transform duration-300">
              <Play className="w-6 h-6 sm:w-8 sm:h-8 text-brand-600 translate-x-0.5" fill="currentColor" />
            </span>
          </span>
          <span className="absolute bottom-4 left-5 right-5 text-left">
            <span className="block text-white font-semibold text-sm sm:text-base">
              Dr. Dione Floyd, LPC-S
            </span>
            <span className="block text-white/75 text-xs sm:text-sm">
              The Wellness Counseling Group · Arlington, TX
            </span>
          </span>
        </button>
      )}
    </div>
  );
}
